import Vue from 'vue';
import SvgIcon from 'vue-svgicon';

import '../assets/icons/vue';

Vue.use(SvgIcon, {
  tagName: 'icon'
});
